module.exports = __webpack_public_path__ + "static/media/Malaysia_logo_2021.f09e41bb.png";